// import { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

// import { editCourseDetails } from "../../../../../services/operations/courseDetailsAPI";
// import { resetCourseState, setStep } from "../../../../../slices/courseSlice";
// import { COURSE_STATUS } from "../../../../../utils/constants";
// import IconBtn from "../../../../common/IconBtn";

// import "./index.css"; // NEW

// export default function PublishCourse() {
//   const { register, handleSubmit, setValue, getValues } = useForm();

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { token } = useSelector((state) => state.auth);
//   const { course } = useSelector((state) => state.course);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (course?.status === COURSE_STATUS.PUBLISHED) {
//       setValue("public", true);
//     }
//   }, []);

//   const goBack = () => {
//     dispatch(setStep(2));
//   };

//   const goToCourses = () => {
//     dispatch(resetCourseState());
//     navigate("/dashboard/my-courses");
//   };

//   const handleCoursePublish = async () => {
//     if (
//       (course?.status === COURSE_STATUS.PUBLISHED &&
//         getValues("public") === true) ||
//       (course?.status === COURSE_STATUS.DRAFT && getValues("public") === false)
//     ) {
//       goToCourses();
//       return;
//     }

//     const formData = new FormData();
//     formData.append("courseId", course._id);
//     const courseStatus = getValues("public")
//       ? COURSE_STATUS.PUBLISHED
//       : COURSE_STATUS.DRAFT;
//     formData.append("status", courseStatus);

//     setLoading(true);
//     const result = await editCourseDetails(formData, token);
//     if (result) {
//       goToCourses();
//     }
//     setLoading(false);
//   };

//   const onSubmit = (data) => {
//     handleCoursePublish();
//   };

//   return (
//     <div className="publish-course-container">
//       <p className="publish-course-title">Publish Settings</p>
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <div className="checkbox-wrapper">
//           <label htmlFor="public" className="checkbox-label">
//             <input
//               type="checkbox"
//               id="public"
//               {...register("public")}
//               className="checkbox-input"
//             />
//             <span className="checkbox-text">Make this course as public</span>
//           </label>
//         </div>

//         <div className="publish-course-buttons">
//           <button
//             disabled={loading}
//             type="button"
//             onClick={goBack}
//             className="back-button"
//           >
//             Back
//           </button>
//           <IconBtn disabled={loading} text="Save Changes" />
//         </div>
//       </form>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { editCourseDetails } from "../../../../../services/operations/courseDetailsAPI";
import { resetCourseState, setStep } from "../../../../../slices/courseSlice";
import { COURSE_STATUS } from "../../../../../utils/constants";
import IconBtn from "../../../../common/IconBtn";

import "./index.css";

export default function PublishCourse() {
  const { register, handleSubmit, setValue, getValues } = useForm({
    defaultValues: { public: false },
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);
  const { course } = useSelector((state) => state.course);
  const [loading, setLoading] = useState(false);

  // -> Run when course changes so edit mode initializes checkbox correctly
  useEffect(() => {
    if (course) {
      setValue("public", course.status === COURSE_STATUS.PUBLISHED, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [course, setValue]);

  const goBack = () => {
    dispatch(setStep(2));
  };

  const goToCourses = () => {
    dispatch(resetCourseState());
    navigate("/dashboard/my-courses");
  };

  const handleCoursePublish = async () => {
    // read current checkbox value
    const isPublic = !!getValues("public");

    // if nothing actually changes, just go back
    if (
      (course?.status === COURSE_STATUS.PUBLISHED && isPublic) ||
      (course?.status === COURSE_STATUS.DRAFT && !isPublic)
    ) {
      goToCourses();
      return;
    }

    const formData = new FormData();
    formData.append("courseId", course._id);
    const courseStatus = isPublic ? COURSE_STATUS.PUBLISHED : COURSE_STATUS.DRAFT;
    formData.append("status", courseStatus);

    setLoading(true);
    const result = await editCourseDetails(formData, token);
    setLoading(false);

    if (result) {
      goToCourses();
    }
  };

  // make onSubmit async to await publish flow if needed
  const onSubmit = async (data) => {
    await handleCoursePublish();
  };

  return (
    <div className="publish-course-container">
      <p className="publish-course-title">Publish Settings</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="checkbox-wrapper">
          <label htmlFor="public" className="checkbox-label">
            <input
              type="checkbox"
              id="public"
              {...register("public")}
              className="checkbox-input"
            />
            <span className="checkbox-text">Make this course as public</span>
          </label>
        </div>

        <div className="publish-course-buttons">
          <button
            disabled={loading}
            type="button"
            onClick={goBack}
            className="back-button"
          >
            Back
          </button>

          {/* Important: make this a submit button */}
          <IconBtn type="submit" disabled={loading} text="Save Changes" />
        </div>
      </form>
    </div>
  );
}
